import React from 'react';
import { toLocalISO } from 'routes/Pages/GenTask/components/SharedFormFields';

const Checkbox = ({ checked }) => (
  <span
    style={{
      display: 'inline-block',
      width: '16px',
      height: '16px',
      border: '1.5px solid #000',
      textAlign: 'center',
      lineHeight: '16px',
      margin: '0 3px',
    }}>
    {checked ? '✓' : ''}
  </span>
);

const ContractDocument = React.forwardRef(
  ({ rowDataCurrent, siteInfoData, siteData, otherInfo, timberPricingData, accountingInfo }, ref) => {
    const currentDate = toLocalISO();
    const rowData = rowDataCurrent?.current;

    const tick = val => <Checkbox checked={val?.toLowerCase() === 'yes'} />;
    const vatRate = Number(siteData?.vatRate) && Number(siteData?.vatRate) !== 0 ? Number(siteData?.vatRate) : 100;

    return (
      <div
        ref={ref}
        style={{
          fontFamily: "'Times New Roman', serif",
          color: '#000',
          padding: '40px 60px',
          backgroundColor: '#fff',
          fontSize: '15px',
          lineHeight: 1.8,
          letterSpacing: '0.2px',
        }}>
        <h5 style={{ textAlign: 'left', marginBottom: '30px', fontWeight: 'bold', fontStyle: 'italic' }}>
          This contract is between Worrell Harvesting Ltd and the undersigned
        </h5>

        {/* Header Information */}
        <div style={{ marginBottom: '15px' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <p>
              <b>Landowner Name:</b> {siteInfoData?.ownerName || '__________'}{' '}
            </p>
            <p>
              <b>Date:</b> {currentDate}
            </p>
          </div>
          <p style={styles.topSpacing}>
            <b>Address:</b> {rowData?.address || '__________'}
          </p>
          <p style={styles.topSpacing}>
            <b>Site location:</b> {rowData?.pricingVersion || '__________'}
          </p>
          <p style={styles.topSpacing}>
            <b>Total area:</b> {timberPricingData[0]?.hectares || '__________'} ha
          </p>
          <p style={styles.topSpacing}>
            <b>WH No (office use):</b> {rowData?.contractUniqueID || '__________'}
          </p>
          <p style={styles.topSpacing}>
            <b>Felling licence no:</b> {rowData?.fellingLicenseNo || '__________'}
          </p>
          <p style={{ fontStyle: 'italic', marginTop: '4px', textDecorationLine: 'underline' }}>
            Please provide a copy of your general felling licence at your earliest convenience to include maps
          </p>
        </div>

        {/* Access Section */}
        <div style={{ marginBottom: '15px' }}>
          <p>
            <b>Access for trucks to be provided from forest to public road.</b>
          </p>
          <p>
            1st Thinning's (trees left 1500-1700) {tick(otherInfo?.firstThinnings)} &nbsp;&nbsp; 2nd Thinning's (tree left
            1000-1200) {tick(otherInfo?.secondThinnings)} &nbsp;&nbsp; Clear-Fell {tick(otherInfo?.clearFell)} &nbsp;&nbsp;
            Others {tick(otherInfo?.others || '_______________')} &nbsp;&nbsp;
          </p>
          <p style={{ marginTop: '4px' }}>
            Trees left per hectare (if different): {otherInfo?.treesLeftPerHectareIfDiff || '______________________________'}
          </p>
          <p style={{ fontStyle: 'italic', marginTop: '16px' }}>
            Note: If you need different quantities left, please state.
          </p>
          <p style={{ marginTop: '4px' }}>
            {otherInfo?.noteIfYouNeedDifferentQtys || '_____________________________________'}
          </p>
        </div>

        {/* Agreement Text */}
        <div style={{ marginBottom: '16px', textAlign: 'justify' }}>
          <p>
            All Timber Removal will be monitored by LOG WATCH via live tracking. The forest owner will get an email or text
            before timber is loaded. You will then get a message when the truck is unloaded with a copy of the weight docket.
            You will also be connected to a live tracking system showing all loads that have left your site. Payment for
            these loads will be made within two weeks from the week they were delivered.
          </p>
          <p style={{ marginTop: '16px' }}>
            Do you require a hard copy to be left in the forest: {tick(otherInfo?.doYouRequireHardCopy)}
          </p>
          <p style={{ marginTop: '16px' }}>
            All timber harvested on-site belongs to Worrell Harvesting and cannot be sold to a third party.
          </p>
          <p style={{ marginTop: '16px' }}>
            Any problems arising should be reported to machine operators, forest manager, or Kenneth Worrell straight away.
          </p>
          <p style={{ marginTop: '16px' }}>Felling plan to be provided in writing (Worrell Harvesting).</p>
          <p>Hi-visibility jackets to be worn on site.</p>
          <p>
            Biomass will be left for 6–11 months or until needles fall off. (If loss of weight occurs, landowner will be
            compensated with minimum full load at 26 tonnes.)
          </p>
          <p>Worrell Harvesting will provide Public and Employers Insurance for the duration of the contract.</p>
          <p style={{ marginTop: '16px' }}>
            Please <b>state*</b> below if any of the following are on the site to be harvested:
          </p>
          <div style={{ marginTop: '8px', lineHeight: 1.8 }}>
            Archaeological area {tick(otherInfo?.archaeologicalArea)} &nbsp;&nbsp; Recreational area{' '}
            {tick(otherInfo?.recreationalArea)} &nbsp;&nbsp; Waterways {tick(otherInfo?.waterways)} &nbsp;&nbsp; Power/phone
            lines {tick(otherInfo?.powerOrPhoneLines)} &nbsp;&nbsp; Rail lines {tick(otherInfo?.railLines)} &nbsp;&nbsp;
            Nearby dwellings {tick(otherInfo?.nearbyDwellings)} &nbsp;&nbsp; Other - Please detail{' '}
            {tick(otherInfo?.otherPleaseDetail)}
          </div>
          {otherInfo?.otherPleaseDetail && (
            <p style={{ marginTop: '8px' }}>Specify Other (if selected): {otherInfo?.otherPleaseDetail}</p>
          )}
        </div>

        {/* Price Offered */}
        <div style={{ marginTop: '16px', paddingTop: '24px', borderTop: '1px solid #000' }}>
          <h5 style={{ textAlign: 'left', textDecoration: 'underline', fontWeight: 'bold' }}>Price Offered</h5>
          <table
            style={{
              width: '100%',
              borderCollapse: 'collapse',
              marginTop: '10px',
            }}>
            <thead>
              <tr>
                <th
                  style={{
                    border: '1px solid #000',
                    padding: '6px',
                    textAlign: 'center',
                  }}>
                  Product
                </th>
                <th
                  style={{
                    border: '1px solid #000',
                    padding: '6px',
                    textAlign: 'center',
                  }}>
                  Product Price
                </th>
                <th
                  style={{
                    border: '1px solid #000',
                    padding: '6px',
                    textAlign: 'center',
                  }}>
                  Product Price (including vat)
                </th>
              </tr>
            </thead>
            <tbody>
              {timberPricingData[0]?.map(item => (
                <tr key={item.id}>
                  <td style={{ border: '1px solid #000', padding: '6px' }}>{item.product}</td>
                  <td style={{ border: '1px solid #000', padding: '6px' }}>€{item.purchasesPrice}</td>
                  <td style={{ border: '1px solid #000', padding: '6px' }}>€{(item.purchasesPrice * vatRate) / 100}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {Array.isArray(timberPricingData[1]) && timberPricingData[1].length > 0 && (
          <div style={{ marginTop: '16px', paddingTop: '24px', borderTop: '1px solid #000' }}>
            <h5 style={{ textAlign: 'left', textDecoration: 'underline', fontWeight: 'bold' }}>Previous Price Offered</h5>
            <table
              style={{
                width: '100%',
                borderCollapse: 'collapse',
                marginTop: '10px',
              }}>
              <thead>
                <tr>
                  <th
                    style={{
                      border: '1px solid #000',
                      padding: '6px',
                      textAlign: 'center',
                    }}>
                    Product
                  </th>
                  <th
                    style={{
                      border: '1px solid #000',
                      padding: '6px',
                      textAlign: 'center',
                    }}>
                    Product Price
                  </th>
                  <th
                    style={{
                      border: '1px solid #000',
                      padding: '6px',
                      textAlign: 'center',
                    }}>
                    Product Price (including vat)
                  </th>
                </tr>
              </thead>
              <tbody>
                {timberPricingData[1]?.map(item => (
                  <tr key={item.id}>
                    <td style={{ border: '1px solid #000', padding: '6px' }}>{item.product}</td>
                    <td style={{ border: '1px solid #000', padding: '6px' }}>€{item.purchasesPrice}</td>
                    <td style={{ border: '1px solid #000', padding: '6px' }}>
                      €{(item.purchasesPrice * (1 + vatRate / 100)).toFixed(2)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        <div style={{ marginTop: '16px' }}>
          <p>VAT Rate: {siteData?.vatRate}</p>
        </div>

        {/* Payment Section */}
        <div style={{ marginTop: '25px', pageBreakBefore: 'always' }}>
          <p style={{ fontWeight: 'bold', textAlign: 'center' }}>(All timber across weighbridge)</p>
          <p>N.B. All drains should be checked by the owner after the site is finished and after the first big rainfall.</p>

          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div>
              <h5 style={{ textAlign: 'left', textDecoration: 'underline', fontWeight: 'bold' }}>Payment Details</h5>
              <p style={styles.topSpacing}>Landowner: {siteInfoData?.ownerName || '__________'}</p>
              <p style={styles.topSpacing}>Phone/Mobile: {siteInfoData?.phone || '__________'}</p>
              <p style={styles.topSpacing}>Email: {siteInfoData?.email || '__________'}</p>
            </div>
            <div>
              <h5 style={{ textAlign: 'left', textDecoration: 'underline', fontWeight: 'bold' }}>Account Details</h5>
              <p style={styles.topSpacing}>Account Holder: {accountingInfo?.accountHolderName || '______________'}</p>
              <p style={styles.topSpacing}>Bank Name: {accountingInfo?.bankName || '______________'}</p>
              <p style={styles.topSpacing}>IBAN: {accountingInfo?.iban || '______________'}</p>
              <p style={styles.topSpacing}>BIC: {accountingInfo?.bic || '______________'}</p>
            </div>
          </div>
        </div>

        <div style={{ marginTop: '30px' }}>
          <p>Notification email {siteInfoData?.email} / and text __________________________________________________</p>
        </div>

        {/* Signatures */}
        <div style={{ marginTop: '30px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <p>Worrell Harvesting Signature</p>
            <img
              src="/Signature/signature.png"
              alt="Worrell Harvesting Signature"
              style={{ marginTop: '8px', height: '40px' }}
            />
            <p style={{ marginTop: '8px' }}>Date: {currentDate}</p>
          </div>
          <div>
            <p>Landowner Signature</p>
            <p style={{ marginTop: '8px' }}>____________________</p>
            <p style={{ marginTop: '8px' }}>Date: _______________</p>
          </div>
        </div>
      </div>
    );
  },
);

export default ContractDocument;

const styles = {
  topSpacing: {
    marginTop: '4px',
  },
};
